<template>
  <div
    class="xm-scroll"
    :class="{
               'pull-down': (state === 0),
               'pull-up': (state === 1),
               refreshing: (state === 2),
               touching: touching,
               'pull-down-disabled': !enableRefresh
             }"
    @touchstart="touchStart($event)"
    @touchmove="touchMove($event)"
    @touchend="touchEnd($event)"
    @scroll="(onInfinite || infiniteLoading) ? onScroll($event) : undefined"
  >
    <div class="scroll-inner" :style="{ transform: 'translate3d(0, ' + top + 'px, 0)' }">
      <div class="pull-to-refresh-layer" v-if="!!onRefresh">
        <slot name="refresh">
          <div class="preloader"></div>
          <div class="pull-to-refresh-arrow">
            <img src="../images/arrow-bottom.png" alt />
          </div>
          <span class="label-down">下拉刷新</span>
          <span class="label-up">释放加载</span>
          <span class="label-refresh">加载中...</span>
        </slot>
      </div>
      <slot></slot>
      <div class="infinite-layer" v-if="enableInfinite">
        <slot name="infinite">
          <div class="infinite-preloader"></div>
          <div>加载中...</div>
        </slot>
      </div>
    </div>
    <div v-if="showToTop" class="back-to-top" @click="handleBackToTop">
      <img
        src="http://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/k6rCZb5tawcX7jQNYTFTZAJy5D752E5D5KnD84e32wkx43DJ1570687753251?x-oss-process=image/resize,w_100"
        alt="back-to-top"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "xm-scroll",
  props: {
    offset: {
      type: Number,
      default: 44
    },
    enableInfinite: {
      type: Boolean,
      default: true
    },
    enableRefresh: {
      type: Boolean,
      default: true
    },
    onRefresh: {
      type: Function,
      default: undefined,
      required: false
    },
    onInfinite: {
      type: Function,
      default: undefined,
      require: false
    },
    keepPosition: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      top: 0,
      state: 0, // 0:down, 1: up, 2: refreshing
      startY: 0,
      touching: false,

      infiniteLoading: false,
      showToTop: false
    };
  },

  methods: {
    touchStart(e) {
      this.startY = e.targetTouches[0].pageY;
      this.startScroll = this.$el.scrollTop || 0;
      this.touching = true;
    },
    touchMove(e) {
      if (!this.enableRefresh || this.$el.scrollTop > 0 || !this.touching) {
        return;
      }
      const diff = e.targetTouches[0].pageY - this.startY - this.startScroll;
      if (diff > 0) e.preventDefault();
      this.top = Math.pow(diff, 0.8) + (this.state === 2 ? this.offset : 0);

      if (this.state === 2) {
        // in refreshing
        return;
      }
      if (this.top >= this.offset) {
        this.state = 1;
      } else {
        this.state = 0;
      }
    },

    touchEnd(e) {
      if (!this.enableRefresh) return;
      this.touching = false;
      if (this.state === 2) {
        // in refreshing
        this.state = 2;
        this.top = this.offset;
        return;
      }
      if (this.top >= this.offset) {
        // do refresh
        this.refresh();
      } else {
        // cancel refresh
        this.state = 0;
        this.top = 0;
      }
    },

    refresh() {
      this.state = 2;
      this.top = this.offset;
      if (!this.onRefresh) {
        this.state = 0;
        this.top = 0;
        return
      }
      this.onRefresh(this.refreshDone);
    },

    refreshDone() {
      this.state = 0;
      this.top = 0;
    },

    infinite() {
      this.infiniteLoading = true;
      this.onInfinite(this.infiniteDone);
    },
    infiniteDone() {
      this.infiniteLoading = false;
    },

    onScroll(e) {
      let $scrollTop = this.$el.scrollTop;
      if ($scrollTop > 0) {
        this.showToTop = true;
      } else {
        this.showToTop = false;
      }
      if (!this.enableInfinite || this.infiniteLoading) {
        return;
      }
      const outerHeight = this.$el.clientHeight;
      const innerHeight = this.$el.querySelector(".scroll-inner").clientHeight;
      const scrollTop = this.$el.scrollTop;
      const ptrHeight = this.onRefresh
        ? this.$el.querySelector(".pull-to-refresh-layer").clientHeight
        : 0;
      const infiniteHeight = this.$el.querySelector(".infinite-layer")
        .clientHeight;
      const bottom = innerHeight - outerHeight - scrollTop - ptrHeight;

      if (bottom < infiniteHeight) this.infinite();
      this.$el.setAttribute(
        "data-vue-keep-scroll-position",
        this.$el.scrollLeft + "-" + this.$el.scrollTop
      );
    },

    handleBackToTop(e) {
      e.preventDefault();
      this._scrollToTop();
    },

    _scrollToTop() {
      let timer;
      let $scrollTop = this.$el.scrollTop;
      let totalTime = 200;
      let eachChip = $scrollTop / 20;
      if (timer) {
        clearInterval(timer);
      } else {
        timer = setInterval(() => {
          this.$el.scrollTop -= eachChip;
          if (this.$el.scrollTop <= 0) {
            clearInterval(timer);
          }
        }, 10);
      }
    }
  },

  activated() {
    if (this.keepPosition) {
      if (this.$el.getAttribute("data-vue-keep-scroll-position")) {
        const pos = this.$el
          .getAttribute("data-vue-keep-scroll-position")
          .split("-");
        this.$el.scrollLeft = Math.min(
          Math.max(pos[0], 0),
          this.$el.scrollWidth - this.$el.offsetWidth
        );
        this.$el.scrollTop = Math.min(
          Math.max(pos[1], 0),
          this.$el.scrollHeight - this.$el.offsetHeight
        );
      }
    }
  }
};
</script>

<style lang='less' rel="stylesheet/less">
@import "../core/variables.less";
@import "../core/mixins.less";

.preloader() {
  width: 20px;
  height: 20px;
  transform-origin: 50%;
  position: absolute;
  left: 50%;
  margin-left: -1rem;
  animation: preloader-spin 1s steps(12, end) infinite;
  &:after {
    display: block;
    width: 100%;
    height: 100%;
    content: "";
    .encoded-svg-background(
      "<svg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><defs><line id='l' x1='60' x2='60' y1='7' y2='27' stroke='#6c6c6c' stroke-width='11' stroke-linecap='round'/></defs><g><use xlink:href='#l' opacity='.27'/><use xlink:href='#l' opacity='.27' transform='rotate(30 60,60)'/><use xlink:href='#l' opacity='.27' transform='rotate(60 60,60)'/><use xlink:href='#l' opacity='.27' transform='rotate(90 60,60)'/><use xlink:href='#l' opacity='.27' transform='rotate(120 60,60)'/><use xlink:href='#l' opacity='.27' transform='rotate(150 60,60)'/><use xlink:href='#l' opacity='.37' transform='rotate(180 60,60)'/><use xlink:href='#l' opacity='.46' transform='rotate(210 60,60)'/><use xlink:href='#l' opacity='.56' transform='rotate(240 60,60)'/><use xlink:href='#l' opacity='.66' transform='rotate(270 60,60)'/><use xlink:href='#l' opacity='.75' transform='rotate(300 60,60)'/><use xlink:href='#l' opacity='.85' transform='rotate(330 60,60)'/></g></svg>"
    );
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: 100%;
  }
}

.preloader-white() {
  &:after {
    .encoded-svg-background(
      "<svg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><defs><line id='l' x1='60' x2='60' y1='7' y2='27' stroke='#fff' stroke-width='11' stroke-linecap='round'/></defs><g><use xlink:href='#l' opacity='.27'/><use xlink:href='#l' opacity='.27' transform='rotate(30 60,60)'/><use xlink:href='#l' opacity='.27' transform='rotate(60 60,60)'/><use xlink:href='#l' opacity='.27' transform='rotate(90 60,60)'/><use xlink:href='#l' opacity='.27' transform='rotate(120 60,60)'/><use xlink:href='#l' opacity='.27' transform='rotate(150 60,60)'/><use xlink:href='#l' opacity='.37' transform='rotate(180 60,60)'/><use xlink:href='#l' opacity='.46' transform='rotate(210 60,60)'/><use xlink:href='#l' opacity='.56' transform='rotate(240 60,60)'/><use xlink:href='#l' opacity='.66' transform='rotate(270 60,60)'/><use xlink:href='#l' opacity='.75' transform='rotate(300 60,60)'/><use xlink:href='#l' opacity='.85' transform='rotate(330 60,60)'/></g></svg>"
    );
  }
}

@keyframes preloader-spin {
  100% {
    transform: rotate(360deg);
  }
}

.encoded-svg-background(@svg) {
  @url: `encodeURIComponent(@{svg}) `;
  background-image: url("data:image/svg+xml;charset=utf-8,@{url}");
}

@layerHeight: 1.2rem;

.pull-to-refresh-layer {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: @layerHeight;
  color: @color-text-gray;

  .preloader {
    visibility: hidden;
    .preloader;
  }
  .pull-to-refresh-arrow {
    width: 0.65rem;
    height: 1rem;
    line-height: 1rem;
    background: no-repeat center;
    background-size: 0.65rem 1rem;
    z-index: 10;
    transform: rotate(0deg) translate3d(0, 0, 0);
    transition-duration: 300ms;
    img {
      display: inline-block;
      height: 0.6rem;
      vertical-align: middle;
    }
  }
}

.xm-scroll {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  &.content {
    position: absolute;
  }

  &.touching .scroll-inner {
    transition-duration: 0ms;
  }
  &:not(.refreshing) {
    .pull-to-refresh-layer .preloader {
      animation: none;
    }
  }
  &.refreshing {
    .pull-to-refresh-arrow {
      visibility: hidden;
      transition-duration: 0ms;
    }
    .preloader {
      visibility: visible;
    }
  }
  &.pull-up {
    .pull-to-refresh-arrow {
      transform: rotate(180deg) translate3d(0, 0, 0);
    }
  }
}
.back-to-top {
  position: fixed;
  bottom: 1.8rem;
  right: 0.32rem;
  z-index: 1001;
  img {
    height: 0.9rem;
  }
}

.scroll-inner {
  position: absolute;
  top: -@layerHeight;
  width: 100%;
  transition-duration: 300ms;
}

.label-down,
.label-up,
.label-refresh {
  display: none;
  text-align: center;
}

.label-refresh {
  width: 5rem;
}

.pull-down .label-down,
.pull-up .label-up,
.refreshing .label-refresh {
  display: block;
  padding-left: 0.5rem;
}

.pull-to-refresh-layer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.infinite-layer {
  height: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: @color-text-gray;
}

.infinite-preloader {
  .preloader;
  margin-right: 0.5rem;
}

.xm-scroll {
  &.pull-down-disabled {
    .scroll-inner {
      top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Scroll.vue